export default "__VITE_ASSET__uZ6N5Xgq__"